"use strict";

var _underscore = require("underscore");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _semver = _interopRequireDefault(require("semver"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ThemeImporterService = /*#__PURE__*/function () {
  ThemeImporterService.$inject = ["$q", "eventService", "accountService", "bulkUpdateService", "assetsService", "metricsService", "urlService", "appScriptService", "themeService", "authHelper"];
  /* @ngInject */
  function ThemeImporterService($q, eventService, accountService, bulkUpdateService, assetsService, metricsService, urlService, appScriptService, themeService, authHelper) {
    _classCallCheck(this, ThemeImporterService);
    this.$q = $q;
    this.eventService = eventService;
    this.accountService = accountService;
    this.bulkUpdateService = bulkUpdateService;
    this.assetsService = assetsService;
    this.appScriptService = appScriptService;
    this.metricsService = metricsService;
    this.urlService = urlService;
    this.themeService = themeService;
    this.currentUser = authHelper.getCurrentUser().name;
  }
  _createClass(ThemeImporterService, [{
    key: "getEventNode",
    value: function getEventNode(event) {
      var eventService = this.eventService;
      return eventService.getEventInstanceNodeName(event);
    }
  }, {
    key: "getAppIconUrl",
    value: function getAppIconUrl(event) {
      var node = event.node || this.getEventNode(event);
      var iconPath = "/api/v1/events/".concat(event._id, "/assets/theme/app-icon");
      return this.urlService.prependRouterRootPathIfOnCloud(node, iconPath);
    }
  }, {
    key: "getAllEvents",
    value: function getAllEvents(user) {
      return this.accountService.getUser(user);
    }
  }, {
    key: "syncAppIcon",
    value: function syncAppIcon() {
      if (_semver.default.lt(window.BSTG.skeletonVersion || '0.0.0', '1.14.0')) {
        return this.appScriptService.callAppScript('theme-editor/sync-app-icon');
      }
      return this.appScriptService.callAppScript('theme-editor/sync-icon');
    }
  }, {
    key: "compileTheme",
    value: function compileTheme(target) {
      return this.themeService.compileTheme(target._id, target.node);
    }

    // target event is in fact the current event
  }, {
    key: "importTheme",
    value: function importTheme(source, target) {
      var _this = this;
      var $q = this.$q,
        eventService = this.eventService,
        bulkUpdateService = this.bulkUpdateService,
        assetsService = this.assetsService,
        metricsService = this.metricsService;
      var importInfo = {
        timestamp: (0, _momentTimezone.default)().unix(),
        source: source._id,
        user: this.currentUser
      };
      source = angular.copy(source);
      source.node = this.getEventNode(source);
      var sourceAddr = [source._id, source.node];
      target = angular.copy(target);
      target.node = this.getEventNode(target);
      var targetAddr = [target._id, target.node];
      var filterBaseBits = function filterBaseBits(bits) {
        return (0, _underscore.filter)(bits, function (bit) {
          return !bit.fp_base_bit;
        });
      };
      var prepareDocsForImport = function prepareDocsForImport(bits) {
        return (0, _underscore.map)(bits, function (bit) {
          bit.fp_import_info = importInfo;
          delete bit._rev;
          delete bit._attachments;
          return bit;
        });
      };
      var getAllDocsOfType = function getAllDocsOfType(event, type) {
        return eventService.getEventDocsByType(event, type).then(function (_ref) {
          var docs = _ref.data;
          return filterBaseBits(docs);
        }, $q.reject);
      };
      var removeDocumentsOfType = function removeDocumentsOfType(event, type) {
        return getAllDocsOfType(event, type).then(function (bits) {
          var ids = (0, _underscore.compact)((0, _underscore.pluck)(bits, 'fp_ext_id'));
          return ids.length === 0 ? $q.resolve(true) : bulkUpdateService.deleteDocs(event._id, event.node, type, ids);
        }, $q.reject);
      };
      var importDocs = function importDocs(docs, type, ignoreAbsentIds) {
        if (!docs || !docs.length) return $q.resolve();
        return bulkUpdateService.createDocs.apply(bulkUpdateService, targetAddr.concat([type, prepareDocsForImport(docs), {
          keepId: true,
          ignoreAbsentIds: ignoreAbsentIds
        }]));
      };
      var importAssets = function importAssets(assets) {
        if (!assets || !assets.length) return $q.resolve({});
        var assetUploadUrl = assetsService.generateRawAssetsPostUrl.apply(assetsService, targetAddr.concat(['theme_asset', 'archive']));
        return _this.runTasks([['blob', function () {
          return assetsService.downloadAssetsToBlob.apply(assetsService, sourceAddr.concat(['theme_asset']));
        }], function (_ref2) {
          var blob = _ref2.blob;
          return assetsService.postRawAssetsDataBlob(assetUploadUrl, blob);
        }, function () {
          return importDocs(assets, 'theme_asset', true);
        }]);
      };
      var trackingId = metricsService.startTracking('theme_import', {
        source: source._id,
        target: target._id
      });

      // a bastardchild of async.auto and async.waterfall
      return this.runTasks([['bits', function () {
        return getAllDocsOfType(source, 'theme-bit');
      }], ['assets', function () {
        return getAllDocsOfType(source, 'theme_asset');
      }], function () {
        return removeDocumentsOfType(target, 'theme-bit');
      }, function () {
        return removeDocumentsOfType(target, 'theme_asset');
      }, function (_ref3) {
        var bits = _ref3.bits;
        return importDocs(bits, 'theme-bit');
      }, function (_ref4) {
        var assets = _ref4.assets;
        return importAssets(assets);
      }, function () {
        return _this.compileTheme(target);
      }, function () {
        return _this.syncAppIcon();
      }, function () {
        metricsService.endTracking(trackingId);
        return $q.resolve(true);
      }]);
    }
  }, {
    key: "runTasks",
    value: function runTasks(tasks) {
      var deferred = this.$q.defer();
      var notify = function notify(m) {
        return deferred.notify(m);
      };
      var memo = {};
      var runTask = function runTask(task) {
        if (!task) {
          return deferred.resolve(memo);
        }
        var taskName = (0, _underscore.isFunction)(task) ? null : task[0];
        var fn = taskName ? task[1] : task;
        var res = fn(memo, notify);
        if (!res || !res.then) {
          console.error('[ThemeImporterService] task did not return a promise', taskName, fn);
          return deferred.reject('Task did not return a promise');
        }
        res.then(function (resp) {
          if (taskName) {
            memo[taskName] = resp;
          }
          runTask(tasks.shift());
        }, function (reason) {
          return deferred.reject(reason);
        });
      };
      runTask(tasks.shift());
      return deferred.promise;
    }
  }]);
  return ThemeImporterService;
}();
angular.module('backstage.services').service('themeImporterService', ThemeImporterService);